<template>
    <div style="width: 120px;">
        <b-form-select v-model="selectedSiteTypeId" @change="onchange" class="gray-select" style="height:41px !important;">
            <option :value="null">{{$t('all')}}</option>
            <option v-for="siteType in siteTypes" :value="siteType.id">{{siteType.name}}</option>
        </b-form-select>
    </div>
</template>

<script>
export default {
    name: 'SiteTypeSelect',
    data() {
        return {
            selectedSiteTypeId: null
        };
    },
    methods: {
        onchange(value) {
            this.$emit('onchange', value);
        }
    },
    created() {
        this.$store.state.siteTypes.forEach(siteType => {
            siteType.name = this.$t(siteType.name);
        });
    }
};
</script>

<style scoped>
</style>

<i18n src="../i18n/common.json"></i18n>



// WEBPACK FOOTER //
// src/components/SiteTypeSelect.vue